<template>
  <div @click="$emit('change')" class="radio-button">
    <div class="button">
      <svg
        v-if="isChecked"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <circle
          cx="8"
          cy="8"
          r="7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="circle"
        />
        <circle cx="8" cy="8" r="2" fill="white" />
      </svg>
      <svg
        v-else
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="8"
          cy="8"
          r="7.5"
          fill="inherit"
          stroke="#C2C2D6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <p class="text mb-0">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.radio-button {
  line-height: 18px;
  display: flex;
  align-items: center;
  .button {
    margin-right: 8px;
    .circle {
      fill: $primary-color2;
      stroke: $primary-color2;
    }
  }
  .text {
    margin-top: 2px;
    color: $title-color;
  }
}

.filter {
  .radio-button {
    .text {
      line-height: 22px;
    }
  }
}

#app[data-theme='dark'] {
  .radio-button {
    .text {
      color: #d6d6d6;
    }
  }
}
</style>
